import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=d84e705e&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=js&"
export * from "./InputTextarea.vue?vue&type=script&lang=js&"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&id=d84e705e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84e705e",
  null
  
)

export default component.exports